<template>
  <div class="marketingPopups" v-if="Onoff">
    <div class="popupsMask" @click.stop="closePopus"></div>

    <div v-if="!subscribed" class="marketing-popups" :class="`marketing-popups--${layout}`">
      <div class="popupsBar">
        <a @click="closePopus">
          <i class="iconfont icon-cm-cancel-1-copy" />
        </a>
      </div>

      <div class="marketing-popups__body">
        <div v-if="layout > 1 && background_image" class="marketing-popups__img">
          <img :src="background_image" alt="" />
        </div>
        <vue-custom-scrollbar class="marketing-popups__content popupsBox" :settings="settings">
          <p v-if="title" class="marketing-popups__title title_font" :style="{ color: title_color }">
            {{ title }}
          </p>

          <p v-if="content" class="marketing-popups__text text_font" :style="{ color: content_color }">
            {{ content }}
          </p>

          <div class="marketing-popups__form">
            <form @submit.prevent.stop="subscription">
              <input type="email" name="name" required v-model="payload.email" placeholder="youremail@email.com" />
              <button :style="{ backgroundColor: button_color }" :class="{ button_active: button_active }">
                {{ button_content }}
              </button>
            </form>
          </div>

          <!-- 底部 -->
          <div class="marketing-popups__footer text_font">
            <p>{{ footer_content }}</p>

            <!-- 分享图标 -->
            <div class="marketing-popups__share" v-if="social_account">
              <a v-if="social_account.ins" :href="social_account.ins">
                <i class="marketing-popups__share-icon--ins iconfont icon-cm-pinterest2"></i>
              </a>
              <a v-if="social_account.faceback" :href="social_account.faceback">
                <i class="marketing-popups__share-icon--fb iconfont icon-cm-facebook2"></i>
              </a>
              <a v-if="social_account.twtter" :href="social_account.twtter">
                <i class="marketing-popups__share-icon--tw iconfont icon-cm-twitter2"></i>
              </a>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>

    <!-- 已订阅 -->
    <div v-else class="subscribed">
      <div class="popupsBar">
        <a @click="closePopus">
          <i class="iconfont icon-cm-cancel-1-copy" />
        </a>
      </div>
      <div class="subscribedContainer">
        <div class="subscribedTitle title_font">
          <p>{{ interactive_settings.popup_title }}</p>
        </div>
        <div class="subscribedCoupon form">
          <div>
            <img
              src="data:image/svg+xml;base64,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"
              alt="Your coupon code"
            />
            <span class="text_font">{{ interactive_settings.code }}</span>
          </div>
          <button v-if="!Copied" @click="copy" :style="{ backgroundColor: interactive_settings.button_color }">
            {{ interactive_settings.button_content }}
          </button>
          <button v-else @click="copy" :style="{ backgroundColor: interactive_settings.button_color }">
            {{ $t('codedisplay.copied') }}
          </button>
        </div>
        <div class="subscribedFoot text_font">
          {{ interactive_settings.popup_content }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
// import API from '../../../API'
export default {
  props: [
    'id',
    'layout',
    'title',
    'title_color',
    'content',
    'content_color',
    'button_content',
    'button_color',
    'footer_content',
    'background_image',
    'interactive_settings',
    'social_account',
  ],
  data() {
    return {
      Onoff: true,
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false,
      },
      payload: {
        email: '',
      },
      button_active: false,
      subscribed: false,
      Copied: false,
    }
  },
  methods: {
    copy() {
      this.copyToClip(this.interactive_settings.code)
      this.Copied = true
    },
    async subscription() {
      try {
        this.button_active = true
        let payload = { ...this.payload, id: this.id }
        await this.$axios.post(`${API.popups}/${this.id}/subscription`, payload)
        this.saveCache('subTime')
        this.button_active = false
        this.subscribed = true
        if (window.snaptr) {
          window.snaptr('track', 'SUBSCRIBE')
        }
      } catch (error) {
        this.button_active = false
        if (error?.response?.data?.message) {
          this.$message.error(error.response.data.message)
        }
      }
    },
    saveCache(key) {
      //去除弹窗缓存
      let cachePopus = localStorage.getItem('cachePopus')
      if (cachePopus) {
        //若缓存数据异常刷新则可恢复
        localStorage.removeItem('cachePopus')
        cachePopus = JSON.parse(cachePopus)
      } else {
        cachePopus = []
      }
      let sw = cachePopus.some((item) => {
        if (item.id && item.id == this.id) {
          item[key] = new Date().getTime()
          return true
        }
      })
      if (!sw) {
        cachePopus.push({
          id: this.id,
          [key]: new Date().getTime(),
        })
      }
      localStorage.setItem('cachePopus', JSON.stringify(cachePopus))
    },
    closePopus() {
      //订阅后的关闭按钮不更新关闭时间
      if (!this.subscribed) this.saveCache('closeTime')

      // 如果打开的是多个弹出，需要全部关闭后，才吧overflow:hidden 去掉
      const marks = document.getElementsByClassName('marketingPopups')
      console.log('marks', marks.length)
      if (!marks || marks.length <= 1) {
        document.body.classList.remove('overflow-hidden')
      }
      this.Onoff = false
    },
  },
  mounted() {
    this.$axios.post(`${API.popups}/${this.id}/view`)
    // this.$("body").css({ overflowY: "hidden" });
    document.body.classList.add('overflow-hidden')
  },
  components: {
    vueCustomScrollbar,
  },
}
</script>
<style lang='scss'>
.marketingPopups {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  text-align: center;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .popupsMask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: none;
  }
  &:first-child {
    .popupsMask {
      background-color: rgba(0, 0, 0, 0.7);
    }
  }
  .marketing-popups {
    box-sizing: border-box;
    position: relative;
    &__body {
      width: 560px;
      max-width: calc(100vw - 30px);
      max-height: calc(100vh - 200px);
      background-color: #fff;
      border-radius: 6px;
      height: 100%;
      overflow: hidden;
    }
    &__content {
      padding: 40px;
    }
    &__title {
      font-size: 24px;
      line-height: 33px;
      font-weight: 500;
      margin-bottom: 0;
      color: #454545;
    }
    &__text {
      margin-top: 20px;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 0;
      color: #454545;
    }
    &__form {
      margin-top: 40px;
      input {
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        width: 100%;
        border: 1px solid #ddd;
        color: #000;
        background: #fff;
        padding: 10px 12px;
        border-radius: 4px;
        line-height: 20px;
        background-clip: padding-box;
      }
      button {
        display: block;
        max-width: 100%;
        margin-top: 20px;
        cursor: pointer;
        background: #05aa9e;
        color: #fff;
        width: 100%;
        font-size: 14px;
        line-height: 20px;
        font-weight: 700;
        border: 1px solid transparent;
        padding: 10px 0;
        text-align: center;
        text-decoration: none;
        border-radius: 4px;
        overflow: hidden;
        background-clip: padding-box;
        transition: opacity 0.3s;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          opacity: 0.8;
        }
      }
    }
    &__img {
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
    &__footer {
      margin-top: 49px;
      & > p {
        font-size: 14px;
        line-height: 20px;
      }
    }
    &__share {
      margin-top: 10px;
      padding-bottom: 0;
      a {
        margin-left: 6px;
        margin-right: 6px;
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
      i {
        font-size: 28px;
      }
    }
    &__share-icon {
      &--fb {
        color: #485893;
      }
      &--tw {
        color: #069ff5;
      }
      &--ins {
        color: #cc1f28;
      }
    }
    &--1 {
      .marketing-popups {
        &__content {
          max-height: calc(100vh - 200px);
        }
      }
    }
    // 上下布局
    &--2 {
      text-align: center;
      .marketing-popups {
        &__img {
          height: 360px;
          width: 100%;
        }
        &__content {
          padding: 20px 40px;
          // max-height: 360px;
          max-height: calc(100vh - 200px - 360px);
        }
        &__text {
          margin-top: 10px;
        }
        &__form {
          margin-top: 30px;
          button {
            margin-top: 10px;
          }
        }
        &__footer {
          margin-top: 20px;
        }
      }
    }
    // 图片居左
    &--3 {
      text-align: left;
      .marketing-popups {
        &__body {
          width: 896px;
          height: 536px;
          display: flex;
        }
        &__img {
          height: 100%;
          width: 536px;
          max-width: 60%;
        }
        &__content {
          flex: 1;
        }
        &__share {
          text-align: left;
        }
      }
    }
    // 图片居右
    &--4 {
      text-align: left;
      .marketing-popups {
        &__body {
          width: 896px;
          height: 536px;
          display: flex;
          flex-direction: row-reverse;
        }
        &__img {
          height: 100%;
          width: 536px;
          max-width: 60%;
        }
        &__content {
          flex: 1;
        }
      }
    }
    .popupsBox {
      overflow-y: auto;
      height: 100%;
      width: 100%;
      .popupsContent {
        padding-bottom: 24px;
        white-space: pre-line;
        p {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: #363d4a;
        }
      }
      .social-sharing {
        span {
          cursor: pointer;
        }
      }
    }

    @media screen and(max-width: 768px) {
      &--2,
      &--3,
      &--4 {
        .marketing-popups {
          &__body {
            // max-height: calc(100vh - 100px);
            max-width: 450px;
            display: flex;
            flex-direction: column;
          }
          &__img {
            height: 215px;
            width: 100%;
            max-width: 100%;
          }
          &__content {
            flex: 1;
            max-height: calc(100vh - 100px - 215px);
            padding: 10px;
          }
          &__form {
            margin-top: 20px;
          }
        }
      }
      &--1 {
        .marketing-popups {
          &__content {
            padding: 20px;
          }
          &__text {
            margin-top: 10px;
          }
          &__form {
            margin-top: 20px;
            button {
              margin-top: 10px;
            }
          }
          &__footer {
            margin-top: 20px;
          }
        }
      }
      &--3,
      &--4 {
        .marketing-popups {
          &__body {
            height: auto;
          }
          &__img {
            height: 0;
            padding-bottom: 100%;
            position: relative;
            display: block;
            img {
              position: absolute;
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }

    @media screen and (max-width: 480px) {
      &--2,
      &--3,
      &--4 {
        .marketing-popups {
          &__body {
            max-width: calc(100vw - 30px);
            max-height: calc(100vh - 100px);
          }
        }
      }
    }
  }


  .subscribed {
    position: absolute;
    border-radius: 6px;
    padding: 40px;
    width: 544px;
    max-width: 90% !important;
    max-height: 80% !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    box-sizing: border-box;
    .subscribedTitle {
      p {
        color: #454545;
        font-size: 24px;
        line-height: 24px;
        margin: 0;
      }
    }
    .subscribedCoupon {
      margin-top: 40px;
      & > div {
        position: relative;
        img {
          width: 100%;
        }
        & > span {
          white-space: nowrap;
          position: absolute;
          top: 50%;
          left: 50%;
          color: #000;
          font-size: 20px;
          line-height: 24px;
          font-weight: 700;
          transform: translate(-50%, -50%);
        }
      }
      button {
        cursor: pointer;
        background: #03a89c;
        padding: 10px;
        width: 100%;
        color: #fff;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        border: 0;
        margin-top: 8px;
        border-radius: 3px;
        background-clip: padding-box;
      }
    }
    .subscribedFoot {
      margin-top: 40px;
      font-size: 14px;
      color: #000;
      background-color: transparent;
      display: block;
    }
  }
  .ps__rail-y {
    width: 4px;
    left: unset !important;
    right: 0;
    .ps__thumb-y {
      width: 4px;
      background-color: #c1cadb;
    }
  }
  .popupsBar {
    position: absolute;
    top: -43px;
    right: 0;
    a {
      cursor: pointer;
      i {
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        opacity: 0.3;
        font-weight: 600;
        color: white;
        background-color: black;
      }
    }
  }
}
@media screen and(max-width: 768px) {
  .marketingPopups {
    .subscribed {
      padding: 20px;
      .subscribedCoupon {
        margin-top: 20px;
      }
      .subscribedFoot {
        margin-top: 20px;
      }
    }
  }
}
</style>
